import type { Update } from '@ngrx/entity';
import type { Uuid } from '@common/types';
import type { NormalizedTabEntity, DenormalizedTabEntity } from '@web/types';

import { createActionGroup, props } from '@ngrx/store';

const TabsActions = createActionGroup({
    source: 'PageStructure/Tabs',
    events: {
        init: props<{ entities: NormalizedTabEntity[] }>(),
        add: props<{ entity: DenormalizedTabEntity; order: number }>(),
        added: props<{ entity: NormalizedTabEntity; order: number }>(),
        'Add many': props<{ entities: NormalizedTabEntity[] }>(),
        create: props<{ parentId: Uuid; order: number; skipHistory?: boolean; meta?: { variant: number } }>(),
        created: props<{
            entity: NormalizedTabEntity;
            order: number;
            skipHistory?: boolean;
            childEntity?: DenormalizedTabEntity;
        }>(),
        'Update properties': props<{ update: Update<NormalizedTabEntity> }>(),
        'Append child': props<{ entityId: string; childId: string; order: number }>(),
        remove: props<{ entity: DenormalizedTabEntity; order?: number; skipHistory?: boolean }>(),
        removed: props<{ entity: NormalizedTabEntity; order?: number; skipHistory?: boolean }>(),
        copy: props<{ entity: DenormalizedTabEntity; order?: number }>(),
        copied: props<{ entity: NormalizedTabEntity; order: number; childEntity?: DenormalizedTabEntity }>(),
    },
});

export default TabsActions;
